import {  GetProjectsSuccessResponse, Project, ProjectResponse } from "../../../types/project";
import { BoardType } from "../../../types/createProject";
import { normalizeApiError } from "../../../utils/normalizeApiError";
import axiosInstance from "../../axiosInstance";

export interface GetAllProjectsParams {
  page?: number;
  size?: number;
  search?: string;
  ownerUuid?: string;
  startDate?: string;
  endDate?: string;
  userUuids?: string[];
  boardType?: BoardType;
  projectStatus?: string;
}

export const getAllProjects = async (
  appUserUuid: string,
  params?: GetAllProjectsParams
): Promise<ProjectResponse> => {
  try {
    const { data } = await axiosInstance.get<any>(
      `/pmo/get-all-projects/${appUserUuid}`,
      { params }
    );

    // Support both old array response and new standard paginated response
    if (data?.response && !Array.isArray(data.response) && data.response.data) {
      return data.response as ProjectResponse;
    }
  
    if (Array.isArray(data?.response) && data?.response?.[0]) {
      return data.response[0] as ProjectResponse;
    }

    // Fallback
    const projects = data?.data ?? [];
    return {
      status: true,
      message: "Success",
      data: projects,
      totalPages: 1,
      totalElements: projects.length,
      currentPage: 0,
      pageSize: projects.length || 20,
    };
  } catch (error) {
    throw normalizeApiError(error);
  }
};

